import { render, staticRenderFns } from "./vendors_create.vue?vue&type=template&id=d07db490&"
import script from "./vendors_create.vue?vue&type=script&lang=js&"
export * from "./vendors_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports